import { IMetaCommand } from "../../../../common/services/cqs/commandManager";

export class InvalidateKontraktCommand implements IMetaCommand {
    $type = "InvalidateKontraktCommand";
    kontraktGuid: string;
    kontraktId: number;
    rowVersion: string;
    get key(): string {
        return this.kontraktGuid;
    }

    constructor(guid: string, id: number, rowVersion: string) {
        this.kontraktGuid = guid;
        this.kontraktId = id;
        this.rowVersion = rowVersion;
    }
}
